import { Component, OnInit, HostListener } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-top',
  templateUrl: './top.component.html',
  styleUrls: ['./top.component.scss'],
})
export class TopComponent implements OnInit {
  constructor(
    private meta: Meta,
    private title: Title,
    private translate: TranslateService
  ) {}
  public arrayPath: string[] = [];

  ngOnInit(): void {
    this.arrayPath = window.location.href.split('/');
    if (this.arrayPath[3] === 'jp' || this.arrayPath[4] === 'jp') {
      this.meta.addTag({
        name: 'description',
        content: '',
      });
      this.title.setTitle('日本医薬品');
      this.translate.use('jp');
      this.translate.setDefaultLang('jp');
    } else {
      this.meta.addTag({
        name: 'description',
        content:
          'We have a multinational and multilingual team of professionals that boast expert knowledge of Japanese pharmaceuticals.Over the years, our group of experts has developed a large network within the pharmaceutical industry, including strong relationships with many distributors and pharmacies throughout Japan.',
      });
      this.title.setTitle('JAPAN PHARMA INC.');
      this.translate.use('en');
      this.translate.setDefaultLang('en');
    }
  }

  public headerClass = 'c-header-transparent';
  public scllor = '';
  @HostListener('window:scroll', []) onWindowScroll() {
    if (window.pageYOffset) {
      this.headerClass = '';
      this.scllor = '';
    } else {
      this.headerClass = 'c-header-transparent';
      this.scllor = 'scllor';
    }
  }

  public getUrl() {
    let language = '';
    this.arrayPath = window.location.href.split('/');
    if (this.arrayPath[3] === 'jp' || this.arrayPath[4] === 'jp') {
      language = '/jp';
    } else {
      language = '';
    }
    return language;
  }
}
